export function formatErrorMessage(errorMessage) {
  const matches = errorMessage.match(/\((.*?)\)/);
  if (matches) {
    const textInBrackets = matches[1];
    const formattedText = textInBrackets.replace(/-/g, " ");
    return formattedText || errorMessage;
  }
  return errorMessage;
}
